import Request from '@/plugins/request';

export function getSaleGoodsMonthlyStats(params) {
  return Request.get('sale-goods-monthly-stats', { params })
}

export function createSaleGoodsMonthlyStat() {
  return Request.get(`sale-goods-monthly-stats/create`)
}

export function storeSaleGoodsMonthlyStat(data) {
  return Request.post('sale-goods-monthly-stats', data)
}

export function updateSaleGoodsMonthlyStat(id, data) {
  return Request.put(`sale-goods-monthly-stats/${id}`, data)
}

export function editSaleGoodsMonthlyStat(id) {
  return Request.get(`sale-goods-monthly-stats/${id}/edit`)
}

export function destroySaleGoodsMonthlyStat(id) {
  return Request.delete(`sale-goods-monthly-stats/${id}`)
}

export function exportSaleGoodsMonthlyStats(params) {
  return Request.get('sale-goods-monthly-stats/export', { params })
}
